import React from 'react';
import PropTypes from 'prop-types';
import { StyledImage } from './styles';

const ImageContainer = ({ src, alt }) => {
  return <StyledImage role="img" src={src} alt={alt} />;
};

ImageContainer.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default ImageContainer;
